module.exports = new __parcel__URL__("firewatch.6aa0c214.jpg").toString();